import React, {
  forwardRef,
  RefObject,
  useEffect,
  useImperativeHandle,
  useLayoutEffect,
  useState,
} from 'react'
import { Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { IModalReference, ISearchReference } from 'shared/models/References'
import { VestigingEnum } from '../../models/Enum'
import { ILocatieGlnModel } from '../../models/ILocatieGlnModel'
import GlnService from '../../service/GlnService'
import { CustomerModel } from 'shared/models/CutomerDeliveryLocations/CustomerModel'
import SearchKoper from 'pages/Locatietoewijzing/LosseKoperComponents/SearchKoper'
import { AflAdrLosseKopersService } from 'services/AflAdrLosseKopersService'
import { IKlant } from 'shared/models/IKlant'

interface RouteToAddressSearchProps {
  onLinkedAddress: (address: ILocatieGlnModel, customer: CustomerModel) => void
  onHide?: () => void
  onShow?: () => void
  showModal?: boolean
  warehouse: VestigingEnum
  customer: CustomerModel
}
const service = new AflAdrLosseKopersService()

function RouteToAddressSearch(
  props: RouteToAddressSearchProps,
  ref: RefObject<IModalReference>
) {
  const [showCustomSearchModal, setShowCustomSearchModal] = useState(false)
  const zoekKlantRef = React.useRef<ISearchReference>()
  const [zoekKlantNummer, setZoekKlantnummer] = useState<number>()
  const [koppelLocaties, setKoppelLocaties] = useState<ILocatieGlnModel[]>()
  const [address, setAddress] = useState('')
  const [errorMessage, setErrorMessage] = useState<string>()
  const [showModal, setShowModal] = useState(false)
  const [location, setLocation] = useState(0)
  const [customer, setCustomer] = useState<CustomerModel>()

  useEffect(() => {
    setCustomer(props.customer)
    setLocation(props.warehouse)
  }, [])

  useLayoutEffect(() => {
    if (props.showModal != null && props.showModal !== showModal) {
      if (props.showModal) {
        show()
      } else {
        hide()
      }
    }
  }, [props.showModal])

  useImperativeHandle(ref, () => ({
    show: () => {
      show()
    },
    hide: () => {
      hide()
    },
  }))

  const handleCloseCustomerSearchView = () => {
    setErrorMessage(null)
    setZoekKlantnummer(null)
    setCustomer(props.customer)
    setShowCustomSearchModal(false)
  }

  const handleShowCustomerSearchView = () => {
    setShowCustomSearchModal(true)
  }

  const customerFound = (result: IKlant) => {
    setErrorMessage(null)
    const tempCustomer: CustomerModel = {
      customerId: result.klantId,
      customerName: result.klantNaam,
      customerNumber: result.klantNummer,
      customerEanCode: result.klantEanCode,
      warehouseId: null,
      connectedAdresses: null,
    }
    setCustomer(tempCustomer)
    setShowCustomSearchModal(false)
  }

  const show = () => {
    setErrorMessage(null)

    if (!showModal) {
      setShowModal(true)
      if (!!props.onShow) {
        props.onShow()
      }
    }
  }

  const hide = () => {
    if (showModal) {
      setShowModal(false)
      if (!!props.onHide) {
        props.onHide()
      }
    }
  }

  const linkedAddress = (linked: ILocatieGlnModel) => {
    props.onLinkedAddress(linked, customer)
    hide()
  }

  const renderLocatieRows = (data: ILocatieGlnModel[]) => {
    return data.map(x => {
      return (
        <tr key={x.locatieGlnId}>
          <td className='pl-4'>{x.locatieGlnCode}</td>
          <td>{x.locatieGlnNaam}</td>
          <td>{x.locatieGlnOmschrijving}</td>
          <td>{getWarehouse(x.vestigingCode)}</td>
          <td>
            <Button variant='primary' onClick={() => linkedAddress(x)}>
              Koppel
            </Button>
          </td>
        </tr>
      )
    })
  }

  const getWarehouse = (code: number): string => {
    return VestigingEnum[code]
  }

  const searchAddressesIfEnter = (e: string) => {
    if (e === 'Enter') {
      searchAddresses()
    }
  }

  const searchAddresses = async () => {
    if (!!address && address.length > 0 && location > 0) {
      const result = await GlnService.getKoppelLocaties(address, location)
      if (result.success) {
        setErrorMessage(null)
        setKoppelLocaties(result.payLoad)
      } else {
        setErrorMessage(result.errorMessage)
        setKoppelLocaties(null)
      }
    }
  }

  const setAddressField = (e: string) => {
    setAddress(e)
    setKoppelLocaties(null)
  }

  const setLocationField = (e: string) => {
    var tempLocationId: number = Number.parseInt(e)
    setLocation(tempLocationId)
    setKoppelLocaties(null)
  }

  return (
    <>
      <Modal
        show={showModal}
        onHide={hide}
        animation={false}
        className='modal-stack2 p-2'
        dialogClassName='new-modal'
        size='xl'
      >
        <Modal.Header closeButton>
          <Modal.Title>Route-to - Locatie zoeken</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorMessage != null && !showCustomSearchModal && (
            <div className='alert alert-danger'>{errorMessage}</div>
          )}

          <table className='selectie mt-n2'>
            <thead>
              <tr>
                <th className='selectie-label w-25'>Klant:</th>
                <th className='selectie-label'></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <strong className='pl-4'>CKN:</strong>
                  <p className='d-inline pl-2'>{customer?.customerNumber}</p>
                </td>
                <td>
                  <strong>Naam:</strong>
                  <p className='d-inline pl-2'>{customer?.customerName}</p>
                </td>
                <td>
                  <Button
                    variant='primary'
                    onClick={handleShowCustomerSearchView}
                    className='float-right'
                  >
                    Wijzig
                  </Button>
                </td>
              </tr>
              <tr>
                <td>
                  <strong className='pl-4'>GLN:</strong>
                  <p className='d-inline pl-2'>{customer?.customerEanCode}</p>
                </td>
              </tr>
            </tbody>
          </table>

          <table className='selectie mt-n5'>
            <thead>
              <tr>
                <th className='selectie-label w-25'>Locaties:</th>
                <th className='selectie-label'></th>
                <th className='selectie-label'></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div className='pl-4'>
                        <OverlayTrigger
                          placement="bottom"
                          overlay={<Tooltip id={''}>De route-to vestiging moet overeen komen met vestiging uit AAR.</Tooltip>}
                        >
                        <strong>{VestigingEnum[location]}</strong>
                        </OverlayTrigger>
                  </div>
                </td>
                <td>
                  <input
                    value={address}
                    placeholder='Geef locatie naam in...'
                    onChange={e => setAddressField(e.target.value)}
                    onKeyUp={e => searchAddressesIfEnter(e.key)}
                  />
                </td>
                <td>
                  <div className='row no-gutters'>
                    <div className='col'></div>
                    <div className='col-auto'>
                      <button
                        className='btn btn-primary'
                        disabled={
                          !address || address.length === 0 || location == 0
                        }
                        onClick={() => searchAddresses()}
                      >
                        Zoeken
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          {!!koppelLocaties && (
            <React.Fragment>
              <table className='selectie mt-n5'>
                <div className='modal-scrolldiv-60'>
                  <thead>
                    <tr>
                      <th className='selectie-label w-25'>Resultaten:</th>
                      <th className='w-25'></th>
                      <th className='w-25'></th>
                      <th className='w-25'></th>
                      <th className='w-10'></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th className='pl-4'>Locatie Gln</th>
                      <th>Locatie Naam</th>
                      <th>Omschrijving</th>
                      <th>Vestiging</th>
                      <th></th>
                    </tr>
                    {renderLocatieRows(koppelLocaties)}
                  </tbody>
                </div>
              </table>
            </React.Fragment>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={hide}>
            Sluiten
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showCustomSearchModal}
        onHide={handleCloseCustomerSearchView}
        animation={false}
        className='modal-stack3 p-2'
        dialogClassName='new-modal'
      >
        <Modal.Header closeButton>
          <Modal.Title>Klant zoeken</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorMessage != null && (
            <div className='alert alert-danger'>{errorMessage}</div>
          )}

          <SearchKoper
            ref={zoekKlantRef}
            service={service}
            warehouse={props.warehouse}
            onError={setErrorMessage}
            onInputChanged={() => setCustomer(null)}
            onResult={customerFound}
            showAARSelectie={false}
            showWarehouseSelectie={false}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleCloseCustomerSearchView}>
            Sluiten
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default forwardRef(RouteToAddressSearch)
